import { EdcTerminalListPage } from "@/features/edc-terminal/pages/EdcTerminalListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/edc-terminal/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["edc_terminals.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: EdcTerminalListPage,
});
